module.exports = __webpack_public_path__ + "img/qg.fd6d9831.jpg";